import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks";

import type { Customer } from "models";
import type { PAGE_SIZE } from "utils/common";

export type CustomerFilters = {
  search_term?: string;
  is_lease_company?: boolean | null;
  page?: number;
  page_size?: PAGE_SIZE;
};

export type ListCustomersResponse = {
  nb_pages: number;
  nb_items: number;
  items: Customer[];
};

const component = "CustomersDashboard";

export const CustomersQueryKeys = {
  filters: localQueryKey<CustomerFilters>({ component, data: "customersFilter" }),
  list: backendQueryKey<ListCustomersResponse>({ baseUrl: ENV.dealerBaseURL, endpoint: "/customers/list", component }),
  selectedCustomer: localQueryKey<Customer | null>({ component, data: "selectedCustomer" })
};
